<template>
<div>
    <!-- Loading Overlay -->
    <div v-if="submitting" class="loading-overlay2">
        <div class="">
            <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <circle cx="50" cy="50" fill="none" stroke="#e9ff86" stroke-width="10" r="35" stroke-dasharray="165 57">
                    <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
            </svg>
        </div>
    </div>

    <!-- Error/Disqualify Popup -->
    <div class="error_popup popup-desktop" v-if="showDisqualify" style="display:flex;">
        <div class="error_box error-pop-desk">
            <div class="text-block-1101" style="font-size: 16px;font-weight: bold;">We Cannot Proceed</div>
            <div class="text-block-1102" style="font-size: 14px;">
                {{ disqualifyMessage || 'Based on your responses, we cannot proceed with your application at this time.' }}
                <br /><br />
                If you believe there was an error in your submission, please click "Resubmit Form" below to update your information.
            </div>
            <div class="button-model-yes-no new-yes-no" style="display: flex;justify-content: center;width: 100%;">
                <a href="#" class="button-107 w-button" @click.prevent="showDisqualify=false;" style="background-color: var(--light-green);color: #fff; text-align: center;">Resubmit Form</a>
            </div>
        </div>
    </div>

    <div class="section-13">
        <!-- Header -->
        <div class="form-3-header-div-2">
            <div class="div-block-2319">
                <a href="#" class="w-inline-block"><img loading="lazy" src="@/assets/images/NewSelf_Logo.webp" alt="" class="image-715"></a>
                <div class="div-block-967">
                    <div class="text-block-152 top">STEP</div>
                    <div class="text-block-151">{{ currentQuestionIndex + 1 }} <span class="text-span-72">of</span> {{ questions.length }}</div>
                    <div class="text-block-152 bottom">COMPLETE</div>
                </div>
            </div>
        </div>
        <div class="div-block-181">
            <div class="girl-div"></div>
        </div>
    </div>

    <!-- Loading State -->
    <div v-if="gettingDetails">
        <div class="dotted-loader"></div>
        <div class="h-80"></div>
    </div>

    <section v-else>
        <div class="step-form-wrap">
            <div class="questions">
                <div class="question-div-copy" v-if="currentQuestion">

                    <h1 class="heading-66" v-html="currentQuestion.label"></h1>
                    <div class="form-subs" v-if="currentQuestion.description" v-html="currentQuestion.description"></div>

                    <!-- String/Integer Input (e.g. weight) -->
                    <div class="form-block-28 w-form" v-if="['string', 'integer'].includes(currentQuestion.question_type)">
                        <form @submit.prevent>
                            <div class="div-block-2320 mobile-entry form _2 weight">
                                <input class="text-field-40 weight w-input" maxlength="256"
                                    v-model="currentAnswer"
                                    :placeholder="currentQuestion.placeholder || 'Enter your answer here'"
                                    type="text"
                                    @input="handleTextInput"
                                    @keydown.enter.prevent="handleNext"
                                    required>
                                <div v-if="currentQuestion.suffix" class="text-block-343 weight">{{ currentQuestion.suffix }}</div>
                            </div>
                        </form>
                    </div>

                    <!-- Text/Textarea Input -->
                    <div class="form-block-28 w-form" v-if="['text', 'textarea'].includes(currentQuestion.question_type)">
                        <form @submit.prevent>
                            <div class="div-block-2321">
                                <textarea :placeholder="currentQuestion.placeholder || 'Please describe in detail...'"
                                    maxlength="5000"
                                    v-model="currentAnswer"
                                    @input="handleTextInput"
                                    @keydown.enter.prevent
                                    class="textarea-6 w-input"></textarea>
                            </div>
                        </form>
                    </div>

                    <!-- Single Option: single confirm-style button -->
                    <div class="form-block-28 w-form" v-if="currentQuestion.question_type === 'single_option' && currentQuestion.options.length === 1" style="display: flex; justify-content: center;">
                        <a href="#" class="form-button-1 w-button"
                            :class="{'selected': isOptionSelected(currentQuestion.options[0].title)}"
                            @click.prevent="handleAnswerSingle(currentQuestion.options[0])">
                            {{ currentQuestion.options[0].title }}
                        </a>
                    </div>

                    <!-- Single Option: multiple choices in rows of 2 -->
                    <div class="form-block-28 w-form" v-if="currentQuestion.question_type === 'single_option' && currentQuestion.options.length > 1">
                        <form @submit.prevent>
                            <div class="div-block-2321">
                                <div class="div-block-965" v-for="(pair, pairIndex) in optionPairs" :key="pairIndex"
                                    :style="pair.length === 1 ? { justifyContent: 'center' } : {}">
                                    <a href="#" v-for="option in pair" :key="option.title"
                                        class="button-55 _4choice w-button"
                                        :class="{'selected': isOptionSelected(option.title)}"
                                        @click.prevent="handleAnswerSingle(option)">
                                        {{ option.title }}
                                    </a>
                                </div>
                            </div>
                        </form>
                    </div>

                    <!-- Multiple Option (checkboxes) -->
                    <div class="form-block-28 w-form" v-if="currentQuestion.question_type === 'multiple_option'">
                        <form @submit.prevent>
                            <div class="div-block-2321">
                                <label class="w-checkbox checkbox-field-15 w-clearfix" v-for="option in currentQuestion.options" :key="option.title"> &nbsp;&nbsp;
                                    <input type="checkbox" :value="option.title" :checked="isOptionSelected(option)" @change="handleCheckboxChange($event, option.title)" class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label">{{ option.title }}</span>
                                </label>
                            </div>
                        </form>
                    </div>

                    <!-- Pharmacy Selection -->
                    <div class="form-block-28 w-form pharmacy-section" v-if="currentQuestion.question_type === 'pharmacy_select'">
                        <div class="pharmacy-search-row">
                            <div class="custom-select-wrapper">
                                <button type="button" class="custom-select-trigger" @click="showSearchTypeDropdown = !showSearchTypeDropdown">
                                    <span>{{ searchTypeLabel }}</span>
                                    <svg class="custom-select-arrow" :class="{ 'open': showSearchTypeDropdown }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <path d="M6 9l6 6 6-6"/>
                                    </svg>
                                </button>
                                <div class="custom-select-dropdown" v-if="showSearchTypeDropdown" @click.stop>
                                    <div class="custom-select-option" :class="{ 'selected': pharmacySearchType === 'zip' }" @click="selectSearchType('zip')">Zip Code</div>
                                    <div class="custom-select-option" :class="{ 'selected': pharmacySearchType === 'city' }" @click="selectSearchType('city')">City</div>
                                    <div class="custom-select-option" :class="{ 'selected': pharmacySearchType === 'state' }" @click="selectSearchType('state')">State</div>
                                    <div class="custom-select-option" :class="{ 'selected': pharmacySearchType === 'name' }" @click="selectSearchType('name')">Name</div>
                                </div>
                                <div class="custom-select-backdrop" v-if="showSearchTypeDropdown" @click="showSearchTypeDropdown = false"></div>
                            </div>
                            <div class="pharmacy-autocomplete">
                                <input type="text" v-model="pharmacySearchTerm"
                                    @input="handlePharmacySearch"
                                    :placeholder="searchPlaceholder"
                                    class="text-field-40 w-input"
                                    autocomplete="off"
                                    :maxlength="pharmacySearchType === 'zip' ? 5 : pharmacySearchType === 'state' ? 2 : 100">
                            </div>
                        </div>
                        <div v-if="selectedPharmacy && !pharmacySearchTerm" class="selected-pharmacy-display" @click="clearPharmacySelection">
                            <div class="selected-pharmacy-info">
                                <strong>{{ selectedPharmacy.name }}</strong>
                                <span>{{ formatPharmacyAddress(selectedPharmacy) }}</span>
                            </div>
                            <span class="clear-selection">&times;</span>
                        </div>
                        <div v-if="searchingPharmacies" class="pharmacy-loading">Searching pharmacies...</div>
                        <div v-if="pharmacyError" class="error-message pharmacy-error">{{ pharmacyError }}</div>
                        <div class="pharmacy-map-container">
                            <div ref="pharmacyMap" class="pharmacy-map"></div>
                        </div>
                        <div v-if="filteredPharmacyResults.length > 0" class="pharmacy-cards-list">
                            <div v-for="pharmacy in filteredPharmacyResults" :key="pharmacy.id"
                                class="pharmacy-card"
                                :class="{ 'pharmacy-card-selected': selectedPharmacy?.id === pharmacy.id }"
                                @click="selectPharmacy(pharmacy)">
                                <div class="pharmacy-card-name">{{ pharmacy.name }}</div>
                                <div class="pharmacy-card-address">{{ formatPharmacyAddress(pharmacy) }}</div>
                                <div v-if="pharmacy.primary_phone" class="pharmacy-card-phone">
                                    {{ formatPhone(pharmacy.primary_phone) }}
                                </div>
                            </div>
                        </div>
                        <div v-if="pharmacySearchTerm.length >= 2 && !searchingPharmacies && pharmacySearchResults.length === 0" class="no-results">
                            No pharmacies found
                        </div>
                    </div>

                    <!-- File Upload -->
                    <div class="form-block-28 w-form" v-if="currentQuestion.question_type === 'image_upload' || currentQuestion.question_type === 'file'">
                        <div class="image-uploader">
                            <div class="upload-box" @dragover.prevent @drop.prevent="handleDrop" :class="{ 'drag-over': isDragging }" @dragenter.prevent="isDragging = true" @dragleave.prevent="isDragging = false">
                                <input type="file" ref="fileInput" @change="handleFileChange" accept="image/*" class="file-input">
                                <div class="upload-content">
                                    <div v-if="uploadLoading" class="loading">Processing...</div>
                                    <div v-else-if="uploadedFile" class="preview">
                                        <img :src="previewUrl" alt="Preview" v-if="previewUrl">
                                        <p class="file-info">{{ uploadedFile.name }} ({{ formatFileSize(uploadedFile.size) }})</p>
                                        <p class="upload-info">Click or drag to upload a new image</p>
                                    </div>
                                    <div v-else class="upload-prompt">
                                        <i class="upload-icon"><img src="@/assets/images/upload-icon.svg"></i>
                                        <p>Drop image here or click to upload</p>
                                        <p class="file-size-info">Maximum file size: 5 MB</p>
                                    </div>
                                </div>
                            </div>
                            <div v-if="uploadError" class="error-message">
                                {{ uploadError }}
                                <div class="error-action">Please try uploading again</div>
                            </div>
                            <div v-if="uploading && uploadProgress > 0" class="upload-progress-container">
                                <div class="upload-progress-bar">
                                    <div class="upload-progress-fill" :style="{ width: uploadProgress + '%' }"></div>
                                </div>
                                <div class="upload-progress-text">Uploading... {{ Math.round(uploadProgress) }}%</div>
                            </div>
                            <div style="display: flex; justify-content: center; width: 100%;">
                                <a href="#" class="form-button-1 w-button" :class="{ 'error-state': uploadError }" @click.prevent="confirmUpload" v-if="uploadedFile && !uploadLoading && !uploading">
                                    {{ uploadButtonText }} <span class="text-span-459">-&gt;</span>
                                </a>
                            </div>
                        </div>
                    </div>

                    <!-- Informational -->
                    <div v-if="currentQuestion.question_type === 'informational'" class="info-message">
                        <a href="#" v-if="currentQuestion.has_next_button !== false" @click.prevent="handleNext" class="form-button-1 w-button">
                            Next <span class="text-span-459">-&gt;</span>
                        </a>
                    </div>

                    <!-- Continue Button (for text/textarea/string/integer/multiple_option/pharmacy - NOT single_option since it auto-advances) -->
                    <a href="#" class="form-button-1 w-button" @click.prevent="handleNext"
                        v-if="['text', 'textarea', 'string', 'integer', 'multiple_option', 'pharmacy_select'].includes(currentQuestion.question_type) && canProceed">
                        Continue <span class="text-span-459">-&gt;</span>
                    </a>

                    <!-- Go Back / Skip row -->
                    <div class="back-link-div" v-if="currentQuestionIndex > 0" style="display: flex; justify-content: space-between; align-items: center;">
                        <a href="#" class="link-block-4 w-inline-block" @click.prevent="goBack()">
                            <div class="text-block-146">&lt; Go Back</div>
                        </a>
                        <a href="#" v-if="currentQuestion.is_optional && (currentQuestion.question_type === 'image_upload' || currentQuestion.question_type === 'file')" class="link-block-4 w-inline-block" @click.prevent="handleSkipImage">
                            <div class="text-block-146">Skip &gt;</div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

const checkOptionProperties = (question, answer) => {
    if (!question.options || !answer) return { important: false, is_critical: false };
    if (Array.isArray(answer)) {
        return answer.reduce((acc, selectedAnswer) => {
            const option = question.options.find(opt => opt.title === selectedAnswer);
            if (option) {
                return {
                    important: acc.important || option.important || false,
                    is_critical: acc.is_critical || option.is_critical || false
                };
            }
            return acc;
        }, { important: false, is_critical: false });
    }
    const option = question.options?.find(opt => opt.title === answer);
    return {
        important: option?.important || false,
        is_critical: option?.is_critical || false
    };
};

export default {
    name: 'UrgentCareFormNew',
    props: {
        userState: {
            type: String,
            default: ''
        },
        amountPaid: {
            type: Number,
            default: 0
        },
        formType: {
            type: String,
            default: 'urgentCare'
        },
        orderId: {
            type: String,
            default: ''
        },
        isPopup: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            currentQuestionIndex: 0,
            answers: {},
            multipleChoiceAnswers: {},
            uploadProgress: 0,
            gettingDetails: true,
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            currentAnswer: '',
            questions: [],
            submitting: false,
            showDisqualify: false,
            disqualifyMessage: '',
            uploadedFile: null,
            previewUrl: '',
            uploadError: '',
            uploadLoading: false,
            uploading: false,
            uploadComplete: false,
            isDragging: false,
            maxFileSizeMB: 5,
            dependencies: [],
            storageKey: '',
            pageLoadTimestamp: Date.now(),
            // Pharmacy specific
            pharmacies: [],
            selectedPharmacy: null,
            loadingPharmacies: false,
            pharmacyError: '',
            pharmacySearchTerm: '',
            pharmacySearchResults: [],
            searchingPharmacies: false,
            showPharmacyDropdown: false,
            showSearchTypeDropdown: false,
            pharmacySearchTimeout: null,
            pharmacySearchType: 'zip',
            // Google Map
            pharmacyMap: null,
            pharmacyMarkers: [],
            infoWindow: null,
            isGoogleMapsLoaded: false,
            // User address fetched from API
            fetchedAddress: null
        }
    },

    computed: {
        ...mapGetters(['user']),
        userZip() {
            return this.fetchedAddress?.zip || '';
        },
        userCity() {
            return (this.fetchedAddress?.city || '').toUpperCase();
        },
        userStateCode() {
            return (this.fetchedAddress?.state || this.userState || '').toUpperCase();
        },
        currentQuestion() {
            return this.questions[this.currentQuestionIndex] || null
        },
        optionPairs() {
            if (!this.currentQuestion?.options) return [];
            const pairs = [];
            for (let i = 0; i < this.currentQuestion.options.length; i += 2) {
                pairs.push(this.currentQuestion.options.slice(i, i + 2));
            }
            return pairs;
        },
        uploadButtonText() {
            if (this.uploading) return 'Uploading...'
            if (this.uploadError) return 'Try Again'
            if (this.uploadComplete) return 'Uploaded!'
            return 'Confirm Upload'
        },
        maxFileSizeBytes() {
            return this.maxFileSizeMB * 1024 * 1024;
        },
        form_id() {
            return this.orderId || this.$route.params.orderId || 'test-form';
        },
        canProceed() {
            if (!this.currentQuestion) return false
            const answer = this.getCurrentAnswer()
            switch (this.currentQuestion.question_type) {
                case 'single_option':
                    return !!answer
                case 'multiple_option':
                    return Array.isArray(answer) && answer.length > 0
                case 'text':
                case 'string':
                case 'textarea':
                    return !!answer && answer.trim().length > 0
                case 'integer':
                    return !isNaN(answer) && answer !== null && answer !== ''
                case 'image_upload':
                    return this.currentQuestion.is_optional || !!answer
                case 'pharmacy_select':
                    return !!this.selectedPharmacy
                case 'informational':
                    return true
                default:
                    return true
            }
        },
        searchTypeLabel() {
            const labels = {
                zip: 'Zip Code',
                city: 'City',
                state: 'State',
                name: 'Name'
            };
            return labels[this.pharmacySearchType] || 'Search by';
        },
        searchPlaceholder() {
            if (this.selectedPharmacy) return '';
            const placeholders = {
                zip: 'Enter zip code...',
                city: 'Enter city name...',
                state: 'Enter state (e.g. FL)...',
                name: 'Enter pharmacy name...'
            };
            return placeholders[this.pharmacySearchType] || 'Search...';
        },
        filteredPharmacyResults() {
            const results = this.pharmacySearchResults;
            if (!results.length) return [];

            if (this.pharmacySearchType !== 'name') return results;

            const zip = this.userZip;
            const city = this.userCity;
            const state = this.userStateCode;

            if (!zip && !city && !state) return results;

            const scored = results.map(p => {
                let score = 0;
                const pZip = (p.zip_code || '').split('-')[0];
                const pCity = (p.city || '').toUpperCase();
                const pState = (p.state || '').toUpperCase();

                if (zip && pZip === zip) score = 3;
                else if (city && state && pCity === city && pState === state) score = 2;
                else if (state && pState === state) score = 1;

                return { pharmacy: p, score };
            });

            const filtered = state
                ? scored.filter(s => s.score > 0)
                : scored;

            filtered.sort((a, b) => b.score - a.score);
            return filtered.map(s => s.pharmacy);
        }
    },

    watch: {
        currentQuestionIndex: {
            handler() {
                this.scrolltoTop();
                this.resetUploadState();
                if (this.currentQuestion && this.currentQuestion.important) {
                    this.validateAnswers();
                }
                this.saveProgressToStorage();
                if (this.currentQuestion?.question_type === 'pharmacy_select') {
                    this.fetchUserAddress();
                    this.loadGoogleMapsForPharmacy();
                }
            }
        },
        answers: {
            handler() {
                this.saveProgressToStorage();
            },
            deep: true
        },
        multipleChoiceAnswers: {
            handler() {
                this.saveProgressToStorage();
            },
            deep: true
        },
        currentAnswer: {
            handler() {
                this.saveProgressToStorage();
            }
        },
        filteredPharmacyResults: {
            handler(results) {
                this.$nextTick(() => {
                    if (!this.isGoogleMapsLoaded) return;
                    const mapEl = this.$refs.pharmacyMap;
                    if (!mapEl) return;
                    if (!this.pharmacyMap || !mapEl.firstChild) {
                        if (results.length) this.initPharmacyMap();
                    } else {
                        this.updateMapMarkers(results);
                    }
                });
            }
        }
    },

    created() {
        this.initializeStorageKey();
        this.initializeQuestions();
    },

    beforeMount() {
        window.addEventListener('beforeunload', this.saveProgressToStorage);
        document.addEventListener('select-pharmacy', this.handleSelectPharmacyFromMap);
    },

    beforeDestroy() {
        window.removeEventListener('beforeunload', this.saveProgressToStorage);
        document.removeEventListener('select-pharmacy', this.handleSelectPharmacyFromMap);
    },

    methods: {
        initializeStorageKey() {
            const userId = this.user?.email || 'anonymous';
            const formId = this.form_id || 'unknown';
            this.storageKey = `urgentCare_progress_${userId}_${formId}`;
        },

        async initializeQuestions() {
            try {
                const response = await fetch('https://newselfrx.s3.us-east-1.amazonaws.com/public/assets/questions/urgentCareQuez.json');

                if (!response.ok) {
                    this.submitting = false;
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const data = await response.json();
                this.questions = data.questions || [];
                this.dependencies = data.dependency || [];

                if (this.questions.length > 0) {
                    await this.loadProgressFromStorage();
                }

                this.gettingDetails = false;
                this.submitting = false;
            } catch (error) {
                console.error('Error fetching questions:', error);
                this.gettingDetails = false;
                this.submitting = false;
            }
        },

        selectSearchType(type) {
            this.pharmacySearchType = type;
            this.showSearchTypeDropdown = false;
            this.onSearchTypeChange();
        },

        formatPhone(phone) {
            return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        },

        onSearchTypeChange() {
            this.pharmacySearchTerm = '';
            this.pharmacySearchResults = [];
            this.pharmacyMarkers.forEach(m => m.setMap(null));
            this.pharmacyMarkers = [];
        },

        handlePharmacySearch() {
            if (this.pharmacySearchTimeout) {
                clearTimeout(this.pharmacySearchTimeout);
            }

            if (this.selectedPharmacy) {
                this.selectedPharmacy = null;
            }

            if (this.pharmacySearchTerm.length < 2) {
                this.pharmacySearchResults = [];
                this.showPharmacyDropdown = false;
                return;
            }

            this.pharmacySearchTimeout = setTimeout(() => {
                this.searchPharmacies();
            }, 300);
        },

        async searchPharmacies(query, searchBy) {
            const searchQuery = query || this.pharmacySearchTerm;
            const searchType = searchBy || this.pharmacySearchType;
            this.searchingPharmacies = true;
            this.pharmacyError = '';
            if (!query) this.showPharmacyDropdown = true;

            try {
                const params = {};
                params[searchType] = searchQuery;
                const response = await this.$axios.get(`${this.baseUrl}/api/search-pharmacies`, {
                    params
                });
                if (response.data?.success) {
                    this.pharmacySearchResults = response.data.data || [];
                } else {
                    this.pharmacySearchResults = [];
                }
            } catch (error) {
                console.error('Error searching pharmacies:', error);
                this.pharmacyError = 'Failed to search pharmacies. Please try again.';
                this.pharmacySearchResults = [];
            } finally {
                this.searchingPharmacies = false;
            }
        },

        selectPharmacy(pharmacy) {
            this.selectedPharmacy = pharmacy;
            this.pharmacySearchTerm = '';
            this.showPharmacyDropdown = false;
            this.highlightSelectedMarker();
            if (this.infoWindow) this.infoWindow.close();
            this.$nextTick(() => this.handleNext());
        },

        clearPharmacySelection() {
            this.selectedPharmacy = null;
            this.pharmacySearchTerm = '';
            this.pharmacySearchResults = [];
            this.pharmacyMarkers.forEach(m => m.setMap(null));
            this.pharmacyMarkers = [];
        },

        async fetchUserAddress() {
            if (this.fetchedAddress) return;
            try {
                const response = await this.$axios.get(`${this.baseUrl}/api/ship-address`);
                if (response.data?.shipping) {
                    this.fetchedAddress = response.data.shipping;
                    if (this.fetchedAddress.zip) {
                        await this.searchPharmacies(this.fetchedAddress.zip, 'zip');
                    }
                }
            } catch (error) {
                console.error('Error fetching user address:', error);
            }
        },

        loadGoogleMapsForPharmacy() {
            if (this.isGoogleMapsLoaded || window.google?.maps) {
                this.isGoogleMapsLoaded = true;
                this.$nextTick(() => this.initPharmacyMap());
                return;
            }
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_KEY}&libraries=places`;
            script.async = true;
            script.defer = true;
            script.onload = () => {
                this.isGoogleMapsLoaded = true;
                this.$nextTick(() => this.initPharmacyMap());
            };
            document.head.appendChild(script);
        },

        initPharmacyMap() {
            const mapEl = this.$refs.pharmacyMap;
            if (!mapEl || !window.google) return;

            this.pharmacyMap = new window.google.maps.Map(mapEl, {
                center: { lat: 39.8283, lng: -98.5795 },
                zoom: 4,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false
            });
            this.infoWindow = new window.google.maps.InfoWindow();

            if (this.filteredPharmacyResults.length) {
                this.updateMapMarkers(this.filteredPharmacyResults);
            }
        },

        updateMapMarkers(pharmacies) {
            this.pharmacyMarkers.forEach(m => m.setMap(null));
            this.pharmacyMarkers = [];

            if (!this.pharmacyMap || !pharmacies || !pharmacies.length) return;

            window.google.maps.event.trigger(this.pharmacyMap, 'resize');

            const bounds = new window.google.maps.LatLngBounds();

            pharmacies.forEach(pharmacy => {
                const lat = parseFloat(pharmacy.latitude || pharmacy.lat || 0);
                const lng = parseFloat(pharmacy.longitude || pharmacy.lng || pharmacy.lon || 0);
                if (!lat || !lng) return;

                const position = { lat, lng };
                const isSelected = this.selectedPharmacy?.id === pharmacy.id;

                const marker = new window.google.maps.Marker({
                    position,
                    map: this.pharmacyMap,
                    title: pharmacy.name,
                    icon: isSelected ? {
                        url: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png'
                    } : undefined
                });

                marker.addListener('click', () => {
                    const phone = pharmacy.primary_phone
                        ? pharmacy.primary_phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                        : '';
                    this.infoWindow.setContent(`
                        <div style="max-width:220px;font-family:sans-serif;">
                            <strong style="font-size:14px;">${pharmacy.name}</strong><br/>
                            <span style="font-size:12px;color:#666;">${this.formatPharmacyAddress(pharmacy)}</span><br/>
                            ${phone ? `<span style="font-size:12px;">📞 ${phone}</span><br/>` : ''}
                            <button onclick="document.dispatchEvent(new CustomEvent('select-pharmacy',{detail:${pharmacy.id}}))"
                                style="margin-top:6px;padding:6px 14px;background:#4CAF50;color:#fff;border:none;border-radius:4px;cursor:pointer;font-size:13px;">
                                Select this pharmacy
                            </button>
                        </div>
                    `);
                    this.infoWindow.open(this.pharmacyMap, marker);
                });

                this.pharmacyMarkers.push(marker);
                bounds.extend(position);
            });

            if (this.pharmacyMarkers.length) {
                this.pharmacyMap.fitBounds(bounds);
                if (this.pharmacyMarkers.length === 1) {
                    this.pharmacyMap.setZoom(14);
                }
            }
        },

        highlightSelectedMarker() {
            this.pharmacyMarkers.forEach((marker, i) => {
                const pharmacy = this.filteredPharmacyResults[i];
                if (!pharmacy) return;
                const isSelected = this.selectedPharmacy?.id === pharmacy.id;
                marker.setIcon(isSelected ? {
                    url: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png'
                } : null);
            });
        },

        handleSelectPharmacyFromMap(e) {
            const pharmacyId = e.detail;
            const pharmacy = this.pharmacySearchResults.find(p => p.id === pharmacyId);
            if (pharmacy) {
                this.selectPharmacy(pharmacy);
            }
        },

        formatPharmacyAddress(pharmacy) {
            const parts = [pharmacy.address1];
            if (pharmacy.address2) parts.push(pharmacy.address2);
            parts.push(`${pharmacy.city}, ${pharmacy.state} ${pharmacy.zip_code}`);
            return parts.join(', ');
        },

        scrolltoTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },

        goBack() {
            if (this.currentQuestionIndex > 0) {
                this.currentQuestionIndex--;
                this.currentAnswer = this.answers[this.currentQuestion.id] || '';
            }
        },

        getCurrentAnswer() {
            if (this.currentQuestion.question_type === 'multiple_option') {
                return this.multipleChoiceAnswers[this.currentQuestion.id] || [];
            }
            if (this.currentQuestion.question_type === 'pharmacy_select') {
                return this.selectedPharmacy;
            }
            return this.answers[this.currentQuestion.id];
        },

        isOptionSelected(option) {
            if (this.currentQuestion.question_type === 'multiple_option') {
                const selectedOptions = this.multipleChoiceAnswers[this.currentQuestion.id] || [];
                return selectedOptions.includes(option.title || option);
            }
            return this.answers[this.currentQuestion.id] === (option.title || option);
        },

        handleAnswerSingle(option) {
            this.$set(this.answers, this.currentQuestion.id, option.title);
            this.saveProgressToStorage();
            setTimeout(() => this.handleNext(), 200);
        },

        isNoneOption(optionTitle) {
            const lower = optionTitle.toLowerCase();
            return lower.startsWith('i do not have') ||
                   lower.startsWith('no i have not') ||
                   lower.startsWith('i have not had') ||
                   lower.startsWith('none');
        },

        handleCheckboxChange(event, optionTitle) {
            if (!this.multipleChoiceAnswers[this.currentQuestion.id]) {
                this.$set(this.multipleChoiceAnswers, this.currentQuestion.id, []);
            }

            if (event.target.checked) {
                if (this.isNoneOption(optionTitle)) {
                    // Clear other selections and only keep this "none" option
                    this.$set(this.multipleChoiceAnswers, this.currentQuestion.id, [optionTitle]);
                    // Auto-advance after a short delay
                    setTimeout(() => this.handleNext(), 300);
                    return;
                }
                // If selecting a regular option, remove any "none" option
                const filtered = this.multipleChoiceAnswers[this.currentQuestion.id].filter(t => !this.isNoneOption(t));
                filtered.push(optionTitle);
                this.$set(this.multipleChoiceAnswers, this.currentQuestion.id, filtered);
            } else {
                const index = this.multipleChoiceAnswers[this.currentQuestion.id].indexOf(optionTitle);
                if (index > -1) {
                    this.multipleChoiceAnswers[this.currentQuestion.id].splice(index, 1);
                }
            }
        },

        handleTextInput() {
            this.$set(this.answers, this.currentQuestion.id, this.currentAnswer);
        },

        validateAnswers() {
            const currentAnswer = this.getCurrentAnswer();
            const { is_critical } = checkOptionProperties(this.currentQuestion, currentAnswer);

            if (is_critical) {
                this.disqualifyMessage = 'Based on your answer, we recommend seeking in-person medical care for your condition.';
                this.showDisqualify = true;
                return false;
            }
            return true;
        },

        shouldShowQuestion(question) {
            if (!question) return false;

            const dependency = this.dependencies.find(dep => dep.question_id === question.id);
            if (!dependency) return true;

            const dependentAnswer = this.answers[dependency.dependent_on];
            if (!dependentAnswer) return false;

            if (Array.isArray(dependentAnswer)) {
                return dependentAnswer.some(ans => dependency.ask_if_val_in.includes(ans));
            }

            return dependency.ask_if_val_in.includes(dependentAnswer);
        },

        handleNext() {
            if (!this.canProceed) return;

            if (this.currentQuestion.question_type === 'pharmacy_select') {
                this.$set(this.answers, this.currentQuestion.id, this.selectedPharmacy);
            } else if (!['single_option', 'multiple_option', 'image_upload'].includes(this.currentQuestion.question_type)) {
                this.$set(this.answers, this.currentQuestion.id, this.currentAnswer);
            }

            if (!this.validateAnswers()) return;

            let nextIndex = this.currentQuestionIndex + 1;
            while (nextIndex < this.questions.length) {
                if (this.shouldShowQuestion(this.questions[nextIndex])) {
                    this.currentQuestionIndex = nextIndex;
                    this.currentAnswer = this.answers[this.currentQuestion.id] || '';
                    return;
                }
                nextIndex++;
            }

            this.handleFinalSubmit();
        },

        async handleFinalSubmit() {
            this.submitting = true;

            const endpoint = `${this.baseUrl}/api/submit-urgent-care-form`;

            const submissionData = {
                ...this.formatAnswers(),
                form_id: this.form_id,
                userInfo: this.user,
                paymentTerms: this.amountPaid,
                selectedPharmacy: this.selectedPharmacy,
                pharmacy_id: this.selectedPharmacy?.id || null,
                isRefil: false,
                frmName: 'urgentCare'
            };

            try {
                await this.$axios.post(endpoint, submissionData);
                await this.clearProgressFromStorage();
                this.submitting = false;
                this.$emit('submitted');
                if (!this.isPopup) {
                    this.$router.push('/urgent-care-thanks');
                }
            } catch (error) {
                console.error('Error submitting form:', error);
                this.submitting = false;
                alert('There was an error submitting your form. Please try again.');
            }
        },

        formatAnswers() {
            const formattedAnswers = [];
            const images = [];
            const additional_details = {};

            this.questions.forEach(question => {
                if (!this.shouldShowQuestion(question)) return;

                let answer = question.question_type === 'multiple_option'
                    ? this.multipleChoiceAnswers[question.id]
                    : this.answers[question.id];
                if (answer === undefined) return;
                if (Array.isArray(answer) && answer.length === 0) return;

                const { important, is_critical } = checkOptionProperties(question, answer);

                const formattedAnswer = {
                    question: question.label,
                    answer: this.formatAnswerValue(answer),
                    type: this.determineAnswerType(question, answer),
                    description: question.description || '',
                    important: important || question.important || false,
                    is_critical: is_critical || question.is_critical || false,
                    label: question.label || '',
                    displayed_options: this.getDisplayedOptions(question)
                };

                if (formattedAnswer.type === 'image_upload') {
                    formattedAnswer.question = question.question;
                    images.push(formattedAnswer);
                } else {
                    formattedAnswers.push(formattedAnswer);
                }
            });

            return {
                answers: formattedAnswers,
                images: images,
                additional_details: additional_details
            };
        },

        formatAnswerValue(answer) {
            if (Array.isArray(answer)) {
                return answer.join('\n');
            }
            if (typeof answer === 'object' && answer !== null) {
                return answer.name || JSON.stringify(answer);
            }
            return String(answer);
        },

        determineAnswerType(question /* , answer */) {
            switch (question.question_type) {
                case 'single_option':
                case 'multiple_option':
                case 'text':
                case 'textarea':
                case 'string':
                    return 'string';
                case 'integer':
                    return 'number';
                case 'file':
                case 'image_upload':
                    return 'image_upload';
                case 'pharmacy_select':
                    return 'pharmacy';
                default:
                    return 'string';
            }
        },

        getDisplayedOptions(question) {
            if (question.options && Array.isArray(question.options)) {
                return question.options.map((option) => option.title);
            }
            return [];
        },

        // File upload methods
        resetUploadState() {
            this.uploadedFile = null;
            this.previewUrl = '';
            this.uploadError = '';
            this.uploadLoading = false;
            this.uploading = false;
            this.uploadComplete = false;
            this.uploadProgress = 0;
        },

        handleDrop(e) {
            this.isDragging = false;
            const file = e.dataTransfer.files[0];
            if (file) {
                this.processUploadFile(file);
            }
        },

        handleFileChange(e) {
            const file = e.target.files[0];
            if (file) {
                this.processUploadFile(file);
            }
        },

        createPreviewUrl(file) {
            if (this.previewUrl) {
                URL.revokeObjectURL(this.previewUrl);
            }
            this.previewUrl = URL.createObjectURL(file);
        },

        async processUploadFile(file) {
            this.uploadError = '';
            this.uploadLoading = true;
            this.uploadedFile = null;
            this.previewUrl = '';
            this.uploadComplete = false;
            this.uploading = false;

            try {
                if (!file) {
                    throw new Error('Please select a file');
                }

                if (!file.type.startsWith('image/')) {
                    throw new Error('Please upload an image file');
                }

                if (file.size > this.maxFileSizeBytes) {
                    throw new Error(`File size exceeds ${this.maxFileSizeMB} MB limit. Please choose a smaller file.`);
                }

                this.uploadedFile = file;
                this.createPreviewUrl(file);
            } catch (err) {
                this.uploadError = err.message;
            } finally {
                this.uploadLoading = false;
            }
        },

        generateUniqueFilename(originalName) {
            const timestamp = new Date().getTime();
            const extension = originalName.split('.').pop();
            const nameWithoutExt = originalName.split('.').slice(0, -1).join('.');
            return `${this.form_id}_${this.currentQuestion.id}_${timestamp}_${nameWithoutExt}.${extension}`;
        },

        async getSignedUrl(filename, contentType) {
            try {
                const response = await fetch(`${this.baseUrl}/api/get-signed-url`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        filename,
                        content_type: contentType
                    })
                });

                if (!response.ok) {
                    throw new Error('Failed to get signed URL');
                }

                return await response.json();
            } catch (error) {
                throw new Error('Error getting signed URL: ' + error.message);
            }
        },

        async uploadToS3(signedUrl, file) {
            return new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();

                xhr.upload.addEventListener('progress', (event) => {
                    if (event.lengthComputable) {
                        this.uploadProgress = Math.round((event.loaded / event.total) * 100);
                    }
                });

                xhr.addEventListener('load', () => {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        this.uploadProgress = 100;
                        resolve();
                    } else {
                        reject(new Error('Failed to upload file to S3'));
                    }
                });

                xhr.addEventListener('error', () => {
                    reject(new Error('Network error during upload. Please check your internet connection.'));
                });

                xhr.addEventListener('abort', () => {
                    reject(new Error('Upload was cancelled'));
                });

                xhr.open('PUT', signedUrl);
                xhr.setRequestHeader('Content-Type', file.type);
                xhr.send(file);
            });
        },

        async confirmUpload() {
            if (!this.uploadedFile || this.uploading) return;

            this.uploading = true;
            this.uploadError = '';
            this.uploadComplete = false;
            this.uploadProgress = 0;

            try {
                const filename = this.generateUniqueFilename(this.uploadedFile.name);

                const urlData = await this.getSignedUrl(filename, this.uploadedFile.type);
                if (!urlData?.url) {
                    throw new Error('Failed to get upload URL');
                }

                await this.uploadToS3(urlData.url, this.uploadedFile);

                await this.$nextTick();

                this.uploadComplete = true;
                this.$set(this.answers, this.currentQuestion.id, filename);

                setTimeout(() => {
                    this.handleNext();
                    this.resetUploadState();
                }, 500);

            } catch (err) {
                console.error('Upload error:', err);

                if (err.message.includes('Failed to fetch') || err.message.includes('Network')) {
                    this.uploadError = 'Upload failed due to connection issues. Please check your internet connection and try again.';
                } else if (err.message.includes('signed URL')) {
                    this.uploadError = 'Error preparing upload. Please try again.';
                } else if (err.message.includes('S3')) {
                    this.uploadError = 'Error uploading file. Please try again.';
                } else {
                    this.uploadError = 'The upload was unsuccessful. Please try again.';
                }
                this.uploadComplete = false;
            } finally {
                this.uploading = false;
                this.uploadProgress = 0;
            }
        },

        formatFileSize(bytes) {
            if (bytes < 1024) return bytes + ' B';
            if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + ' KB';
            return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
        },

        handleSkipImage() {
            this.resetUploadState();
            this.$set(this.answers, this.currentQuestion.id, null);
            this.handleNext();
        },

        // Progress storage methods
        saveProgressToStorage() {
            try {
                const progress = {
                    currentQuestionIndex: this.currentQuestionIndex,
                    answers: this.answers,
                    multipleChoiceAnswers: this.multipleChoiceAnswers,
                    selectedPharmacy: this.selectedPharmacy,
                    timestamp: Date.now()
                };
                localStorage.setItem(this.storageKey, JSON.stringify(progress));
            } catch (error) {
                console.error('Error saving progress:', error);
            }
        },

        async loadProgressFromStorage() {
            try {
                const saved = localStorage.getItem(this.storageKey);
                if (saved) {
                    const progress = JSON.parse(saved);
                    this.currentQuestionIndex = progress.currentQuestionIndex || 0;
                    this.answers = progress.answers || {};
                    this.multipleChoiceAnswers = progress.multipleChoiceAnswers || {};
                    this.selectedPharmacy = progress.selectedPharmacy || null;
                    this.currentAnswer = this.answers[this.currentQuestion?.id] || '';
                }
            } catch (error) {
                console.error('Error loading progress:', error);
            }
        },

        async clearProgressFromStorage() {
            try {
                localStorage.removeItem(this.storageKey);
            } catch (error) {
                console.error('Error clearing progress:', error);
            }
        }
    }
};
</script>

<style scoped>
.image-uploader {
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
}

.upload-box {
    position: relative;
    border: 2px dashed #ccc;
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-bottom: 15px;
}

.upload-box:hover {
    border-color: #666;
}

.drag-over {
    border-color: #2196F3;
    background-color: rgba(33, 150, 243, 0.1);
}

.file-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
}

.upload-content {
    padding: 20px;
}

.upload-icon {
    font-size: 48px;
    margin-bottom: 10px;
}

.upload-prompt p {
    margin: 10px 0;
    font-size: 16px;
    color: #666;
}

.file-size-info {
    font-size: 14px;
    color: #999;
    margin-top: 5px;
}

.file-info {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    margin: 5px 0;
}

.upload-info {
    font-size: 14px;
    color: #999;
}

.preview {
    margin: 10px 0;
}

.preview img {
    max-width: 100%;
    max-height: 300px;
    border-radius: 4px;
    margin-bottom: 10px;
}

.loading {
    padding: 20px;
    color: #666;
}

.error-message {
    color: #f44336;
    margin-top: 10px;
    font-size: 14px;
    padding: 10px;
    background-color: #ffebee;
    border-radius: 4px;
    border: 1px solid #ffcdd2;
}

.error-action {
    margin-top: 5px;
    font-weight: 500;
}

.error-state {
    background-color: #f44336 !important;
    border-color: #d32f2f !important;
}

.error-state:hover {
    background-color: #d32f2f !important;
}

.upload-progress-container {
    margin-bottom: 15px;
}

.upload-progress-bar {
    width: 100%;
    height: 8px;
    background-color: #f0f0f0;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 8px;
}

.upload-progress-fill {
    height: 100%;
    background: linear-gradient(90deg, #2196F3, #21CBF3);
    transition: width 0.3s ease;
    border-radius: 4px;
}

.upload-progress-text {
    text-align: center;
    font-size: 14px;
    color: #666;
    font-weight: 500;
}

/* Pharmacy Section */
.pharmacy-section {
    width: 100%;
}

.pharmacy-search-row {
    display: flex;
    gap: 12px;
    margin-bottom: 16px;
}

.custom-select-wrapper {
    position: relative;
    min-width: 120px;
    flex-shrink: 0;
}

.custom-select-trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 14px 16px;
    border: 1px solid #e5e5e5;
    border-radius: 12px;
    font-size: 15px;
    font-weight: 500;
    background: #fff;
    cursor: pointer;
    width: 100%;
    color: #171717;
    text-align: left;
    font-family: inherit;
}

.custom-select-trigger:hover {
    border-color: #d4d4d4;
}

.custom-select-arrow {
    width: 18px;
    height: 18px;
    color: #737373;
    transition: transform 0.2s ease;
    flex-shrink: 0;
}

.custom-select-arrow.open {
    transform: rotate(180deg);
}

.custom-select-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9998;
}

.custom-select-dropdown {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    background: #fff;
    border: 1px solid #e5e5e5;
    border-radius: 12px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
    z-index: 9999;
    overflow: hidden;
}

.custom-select-option {
    padding: 14px 16px;
    font-size: 15px;
    cursor: pointer;
    color: #171717;
    transition: background-color 0.15s ease;
}

.custom-select-option:hover {
    background-color: #f5f5f5;
}

.custom-select-option.selected {
    background-color: #e9ff86;
    color: #08466f;
    font-weight: 600;
}

.pharmacy-autocomplete {
    flex: 1;
}

.pharmacy-autocomplete input {
    width: 100%;
}

.selected-pharmacy-display {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: #f0faf0;
    border: 1px solid #4CAF50;
    border-radius: 8px;
    cursor: pointer;
    margin-bottom: 16px;
}

.selected-pharmacy-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    overflow: hidden;
}

.selected-pharmacy-info strong {
    font-size: 14px;
    color: #171717;
}

.selected-pharmacy-info span {
    font-size: 12px;
    color: #666;
}

.clear-selection {
    font-size: 20px;
    color: #999;
    cursor: pointer;
    padding: 0 5px;
    flex-shrink: 0;
}

.clear-selection:hover {
    color: #333;
}

.pharmacy-loading {
    padding: 12px;
    text-align: center;
    color: #666;
    font-size: 14px;
}

.pharmacy-error {
    padding: 10px;
    background-color: rgba(220, 38, 38, 0.2);
    border: 1px solid #DC2626;
    color: #f87171;
    border-radius: 8px;
    font-size: 14px;
    margin-bottom: 16px;
}

.pharmacy-map-container {
    width: 100%;
    margin: 16px 0;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #e5e5e5;
}

.pharmacy-map {
    width: 100%;
    height: 250px;
}

.pharmacy-cards-list {
    max-height: 250px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
}

.pharmacy-card {
    padding: 12px 16px;
    border: 1px solid #e5e5e5;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    background: #fff;
}

.pharmacy-card:hover {
    border-color: #999;
    background-color: #fafafa;
}

.pharmacy-card-selected {
    border-color: #4CAF50 !important;
    background-color: #f0faf0 !important;
}

.pharmacy-card-name {
    font-size: 14px;
    font-weight: 600;
    color: #171717;
    margin-bottom: 4px;
}

.pharmacy-card-address {
    font-size: 12px;
    color: #666;
    margin-bottom: 2px;
}

.pharmacy-card-phone {
    font-size: 12px;
    color: #888;
}

.no-results {
    padding: 12px;
    text-align: center;
    color: #666;
    font-size: 14px;
}

@media screen and (max-width: 767px) {
    .pharmacy-search-row {
        flex-direction: column;
        gap: 12px;
    }

    .custom-select-wrapper {
        width: 100%;
    }

    .custom-select-trigger {
        padding: 16px 18px;
        font-size: 16px;
    }

    .custom-select-option {
        padding: 16px 18px;
        font-size: 16px;
    }

    .custom-select-backdrop {
        background: transparent;
    }

    .pharmacy-map {
        height: 180px;
    }

    .pharmacy-cards-list {
        max-height: 300px;
    }

    .pharmacy-card {
        padding: 14px 16px;
        border-radius: 12px;
    }
}
</style>
